
import { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { placeOrder } from '../../api/apiServices';

export default function CartDrawer() {
  const { cartItems, isCartOpen, setIsCartOpen, removeFromCart, updateQuantity, cartTotal, clearCart } = useCart();
  const [isCheckout, setIsCheckout] = useState(false);

  const [form, setForm] = useState({
  email: "",
  firstName: "",
  lastName: "",
  address: "",
  city: "",
  state: "",
  phone: "",
  paymentMethod: "card"
});

const [loading, setLoading] = useState(false);

  const shippingFee = cartTotal > 30000 ? 0 : 0;
  const grandTotal = cartTotal + shippingFee;

  const handleChange = (e) => {
  setForm({ ...form, [e.target.name]: e.target.value });
};

  const handleCheckout = () => {
    setIsCheckout(true);
  };

  const handlePlaceOrder = async () => {
  try {
    setLoading(true);

    const res = await placeOrder(form);

    // redirect to paystack
    window.location.href = res.order.paystackAuthUrl;

  } catch (err) {
    alert(err.response?.data?.message || "Failed to place order");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 z-50 transition-opacity duration-300 ${isCartOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => { setIsCartOpen(false); setIsCheckout(false); }}
      />
      <div
        className={`fixed top-0 right-0 h-full w-full max-w-md bg-white z-50 shadow-2xl transition-transform duration-300 ease-out ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <div className="flex items-center gap-3">
              {isCheckout && (
                <button
                  onClick={() => setIsCheckout(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-lg"></i>
                </button>
              )}
              <h2 className="font-['Playfair_Display'] text-xl font-bold text-gray-800">
                {isCheckout ? 'Checkout' : 'Your Cart'}
              </h2>
            </div>
            <button
              onClick={() => { setIsCartOpen(false); setIsCheckout(false); }}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
          </div>

          {!isCheckout ? (
            <>
              <div className="flex-1 overflow-y-auto px-6 py-4">
                {cartItems.length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-center">
                    <div className="w-20 h-20 flex items-center justify-center bg-pink-50 rounded-full mb-4">
                      <i className="ri-shopping-bag-line text-3xl text-lilac-400"></i>
                    </div>
                    <p className="font-['Poppins'] text-gray-800 font-medium mb-2">Your cart is empty</p>
                    <p className="font-['Poppins'] text-gray-500 text-sm">Add some beautiful pieces to get started!</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {cartItems.map((item) => (
                      <div key={`${item.id}-${item.size}`} className="flex gap-4 p-3 bg-gray-50 rounded-xl">
                        <div className="w-20 h-24 bg-white rounded-lg overflow-hidden flex-shrink-0">
                          <img src={item.image} alt={item.name} className="w-full h-full object-cover object-top" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-['Poppins'] font-medium text-gray-800 text-sm truncate">{item.name}</p>
                          <p className="font-['Poppins'] text-gray-500 text-xs mt-0.5">Size: {item.size}</p>
                          <p className="font-['Poppins'] font-bold text-lilac-400 text-sm mt-1">
                            ₦{item.price.toLocaleString()}
                          </p>
                          <div className="flex items-center justify-between mt-2">
                            <div className="flex items-center gap-2">
                              <button
                                onClick={() => updateQuantity(item.product, item.size, item.quantity - 1)}
                                className="w-7 h-7 flex items-center justify-center rounded-md bg-white border border-gray-200 hover:border-lilac-400 transition-colors cursor-pointer"
                              >
                                <i className="ri-subtract-line text-sm"></i>
                              </button>
                              <span className="font-['Poppins'] text-sm w-6 text-center">{item.quantity}</span>
                              <button
                                onClick={() => updateQuantity(item.product, item.size, item.quantity + 1)}
                                className="w-7 h-7 flex items-center justify-center rounded-md bg-white border border-gray-200 hover:border-lilac-400 transition-colors cursor-pointer"
                              >
                                <i className="ri-add-line text-sm"></i>
                              </button>
                            </div>
                            <button
                              onClick={() => removeFromCart(item.product, item.size)}
                              className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-red-50 hover:text-red-500 transition-colors cursor-pointer"
                            >
                              <i className="ri-delete-bin-line text-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {cartItems.length > 0 && (
                <div className="border-t border-gray-100 px-6 py-4 bg-white">
                  <div className="space-y-2 mb-4">
                    <div className="flex justify-between font-['Poppins'] text-sm">
                      <span className="text-gray-500">Subtotal</span>
                      <span className="text-gray-800">₦{cartTotal.toLocaleString()}</span>
                    </div>
                    {/* <div className="flex justify-between font-['Poppins'] text-sm">
                      <span className="text-gray-500">Shipping</span>
                      <span className="text-gray-800">{shippingFee === 0 ? 'Free' : `₦${shippingFee.toLocaleString()}`}</span>
                    </div> */}
                    <div className="flex justify-between font-['Poppins'] font-bold pt-2 border-t border-gray-100">
                      <span className="text-gray-800">Total</span>
                      <span className="text-lilac-400">₦{grandTotal.toLocaleString()}</span>
                    </div>
                  </div>
                  <button
                    onClick={handleCheckout}
                    className="w-full py-4 bg-lilac-400 text-white rounded-xl font-['Poppins'] font-semibold hover:bg-lilac-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Proceed to Checkout
                  </button>
                  {cartTotal < 30000 && (
                    <p className="text-center text-xs text-gray-500 mt-3 font-['Poppins']">
                      Add ₦{(30000 - cartTotal).toLocaleString()} more for free shipping!
                    </p>
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              <div className="flex-1 overflow-y-auto px-6 py-4">
                <div className="space-y-6">
                  <div>
                    <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-3">Contact Information</h3>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="Email address"
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                    />
                  </div>

                  <div>
                    <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-3">Shipping Address</h3>
                    <div className="space-y-3">
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="text"
                          name="firstName"
                          value={form.firstName}
                          onChange={handleChange}
                          placeholder="First name"
                          className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                        />
                        <input
                          type="text"
                          name="lastName"
                          value={form.lastName}
                          onChange={handleChange}
                          placeholder="Last name"
                          className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                        />
                      </div>
                      <input
                        type="text"
                        name="address"
                        value={form.address}
                        onChange={handleChange}
                        placeholder="Address"
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                      />
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="text"
                          name="city"
                          value={form.city}
                          onChange={handleChange}
                          placeholder="City"
                          className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                        />
                        <input
                          type="text"
                          name="state"
                          value={form.state}
                          onChange={handleChange}
                          placeholder="State"
                          className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                        />
                      </div>
                      <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="Phone number"
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl font-['Poppins'] text-sm focus:outline-none focus:border-lilac-400 transition-colors"
                      />
                    </div>
                  </div>

                  {/* <div>
                    <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-3">Payment Method</h3>
                    <div className="space-y-2">
                      <label className="flex items-center gap-3 p-4 border border-gray-200 rounded-xl cursor-pointer hover:border-lilac-400 transition-colors">
                        <input 
                        type="radio" 
                        name="paymentMethod"
                        value="card"
                        checked={form.paymentMethod === "card"}
                        onChange={handleChange}
                        defaultChecked 
                        className="w-4 h-4 accent-lilac-400" />
                        <i className="ri-bank-card-line text-lg text-gray-600"></i>
                        <span className="font-['Poppins'] text-sm text-gray-700">Card Payment</span>
                      </label>
                      <label className="flex items-center gap-3 p-4 border border-gray-200 rounded-xl cursor-pointer hover:border-lilac-400 transition-colors">
                        <input type="radio" 
                        name="paymentMethod"
                        value="cod"
                        checked={form.paymentMethod === "cod"}
                        onChange={handleChange}
                        className="w-4 h-4 accent-lilac-400" />
                        <i className="ri-hand-coin-line text-lg text-gray-600"></i>
                        <span className="font-['Poppins'] text-sm text-gray-700">Pay on Delivery</span>
                      </label>
                    </div>
                  </div> */}

                  <div>
  <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-3">
    Payment
  </h3>

  <div className="border border-gray-200 rounded-xl p-4 bg-gradient-to-br from-gray-50 to-white">

    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 rounded-lg bg-[#00C3F7]/10 flex items-center justify-center">
        <i className="ri-secure-payment-line text-xl text-[#00C3F7]"></i>
      </div>

      <div>
        <p className="font-medium text-gray-800 text-sm">
          Pay with Card / Bank Transfer
        </p>
        <p className="text-xs text-gray-500">
          Secure payment powered by Paystack
        </p>
      </div>
    </div>

    <div className="flex items-center gap-2 text-xs text-gray-500">
      <span className="px-2 py-1 bg-white border rounded">Visa</span>
      <span className="px-2 py-1 bg-white border rounded">Mastercard</span>
      <span className="px-2 py-1 bg-white border rounded">Verve</span>
      <span className="px-2 py-1 bg-white border rounded">Transfer</span>
      <span className="px-2 py-1 bg-white border rounded">USSD</span>
    </div>

    <p className="text-xs text-gray-400 mt-3">
      You will be redirected to a secure payment page after placing your order.
    </p>

  </div>
</div>


                  <div className="bg-gray-50 rounded-xl p-4">
                    <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-3">Order Summary</h3>
                    <div className="space-y-2 text-sm font-['Poppins']">
                      {cartItems.map((item) => (
                        <div key={`${item.id}-${item.size}`} className="flex justify-between">
                          <span className="text-gray-600">{item.name} x{item.quantity}</span>
                          <span className="text-gray-800">₦{(item.price * item.quantity).toLocaleString()}</span>
                        </div>
                      ))}
                      {/* <div className="flex justify-between pt-2 border-t border-gray-200">
                        <span className="text-gray-500">Shipping</span>
                        <span className="text-gray-800">{shippingFee === 0 ? 'Free' : `₦${shippingFee.toLocaleString()}`}</span>
                      </div> */}
                      <div className="flex justify-between font-bold pt-2 border-t border-gray-200">
                        <span className="text-gray-800">Total</span>
                        <span className="text-lilac-400">₦{grandTotal.toLocaleString()}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-100 px-6 py-4 bg-white">
                <button
                disabled={loading}
                  onClick={handlePlaceOrder}
                  className="w-full py-4 bg-lilac-400 text-white rounded-xl font-['Poppins'] font-semibold hover:bg-lilac-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {loading ? "Processing..." : `Place Order - ₦${grandTotal.toLocaleString()}`}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
